/**
 * Department
 */
export class Department {
  /**
   * id
   */
  id: number;

  /**
   * description
   */
  description: string;

  /**
   * emails
   */
  emails: string;

  /**
   * mobiles
   */
  mobiles: string;

  /**
   * Create instance from JSON
   *
   * @param json Object
   *
   * @returns Department instance
   */
  static createFromJson(json: object): Department {
    const self = new this();

    Object.keys(json).forEach((key) => {
      self[key] = json[key];
    });

    return self;
  }
}
